export const messages = {
  de: require('./de.json'),
  en: require('./en.json'),
  fr: require('./fr.json'),
  nl: require('./nl.json'),
  it: require('./it.json'),
}
